import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useCurrentReviewer } from '../../../../../hooks/reviewers/useCurrentReviewer';
import styles from './WelcomePanel.module.scss';
import { Message, Heading, Text } from 'components/core';

const WelcomePanel = () => {
  const { currentReviewer } = useCurrentReviewer();
  const name = currentReviewer?.first_name
    ? `${currentReviewer.first_name} `
    : '';

  const { getValues } = useFormContext();
  const newTemplate = !getValues('updated_by');

  const title = `Welcome ${newTemplate ? '' : 'back '}${name}${
    newTemplate ? '👋' : '🙌'
  }`;

  return (
    <Message icon={false} className={styles.WelcomeSection} dismissible={false}>
      <Heading variant="brand" type="h3" component="h2">
        {title}
      </Heading>
      {newTemplate ? (
        <Text size="sm">
          You’re about to create your data extraction template. This template
          defines what information you’ll collect from each study to answer your
          review question. It helps you to collect the right data, quickly and
          consistently.
          <br /> <br />
          Don’t worry about getting it perfect the first time - you can update
          it anytime! Just edit the five sections below to get started.
        </Text>
      ) : (
        <Text size="sm">
          Need to make changes? No problem! You can edit this template at any
          time during the data extraction process.
        </Text>
      )}
    </Message>
  );
};

export default WelcomePanel;
